import { render, staticRenderFns } from "./PedidosAbiertosTable.vue?vue&type=template&id=165aaaad"
import script from "./PedidosAbiertosTable.vue?vue&type=script&lang=js"
export * from "./PedidosAbiertosTable.vue?vue&type=script&lang=js"
import style0 from "./PedidosAbiertosTable.vue?vue&type=style&index=0&id=165aaaad&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports